<template>
  <div>
    <el-drawer
      class="sideDrawer"
      :size="drawerSize"
      destroy-on-close
      title="仓库存货核算编辑"
      :visible.sync="dialogShow"
      :before-close="handleClose"
      :wrapperClosable="false"
      :close-on-press-escape="false"
    >
      <i class="iconfont icon-back-quanping iconFull" @click="drawerSize = '100%'" v-if="drawerSize == '70%'" />
      <i @click="drawerSize = '70%'" class="iconfont icon-back-tuichuquanping iconFull" v-else />
      <div class="form-content" style="padding: 20px">
        <el-form ref="form" label-width="150px">
          <el-form-item label="计价方式：">
            <el-select v-model="value" placeholder="请选择">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </el-form>
        <div>
          <p>备注：</p>
          <p>1、启动存货核算功能时，系统默认按照“个别计价法”出库;</p>
          <p>2、计价方式可由“个别计价法”变为”移动加权平均法”;</p>
          <p>3、计价方式变为”移动加权平均法“后，不能再改变计价方式;</p>
          <p>4、启动存货核算功能后，系统会自动生成本年存货账期，可对上月进行结账处理，视为初始化账期。</p>
        </div>
      </div>
      <div class="demo-drawer__footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleSave" v-loading.fullscreen.lock="loading">确 定</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import utils from '@/utils.js'
export default {
  computed: {
    ...mapState({
      allEnumerate: (state) => state.user.allEnumerate
    })
  },
  data() {
    return {
      drawerSize: '70%',
      value: '1',
      dialogShow: false,
      tenantId: '-1',
      loading: false,
      showPerson: false,
      noticeTimeShow: false,
      options: [],
      receivablesData: []
    }
  },
  mounted() {
    let that = this
    that.$nextTick(() => {
      that.options = utils.getAllEnumerateAttr({
        isShowList: true,
        typeKey: 'PricingMethodEnum',
        allData: that.allEnumerate
      })
    })
  },
  methods: {
    // 根据租户获取配置
    getDetail() {
      let that = this
      that.dialogShow = true
      that.$http.get('${portal}/portal/data_switch_config/getByKey?typeKey=warehouse_inventory_accounting').then((resp) => {
        if (resp && resp.data) {
          this.value = resp.data.pricing_method ? resp.data.pricing_method : '1'
        }
      })
    },
    //关闭表单
    handleClose() {
      this.dialogShow = false
      this.$emit('close')
    },
    //提交表单
    handleSave() {
      this.loading = true
      const param = {
        pricing_method: this.value,
        type_key: 'warehouse_inventory_accounting',
        is_open: 1
      }
      this.$http
        .put('${portal}/portal/data_switch_config/update_default', param)
        .then((res) => {
          if (res.data.state) {
            this.loading = false
            this.$message.success('保存成功！')
          } else {
            this.loading = false
            this.$message.error('保存失败！')
          }
          this.handleClose()
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped>
.dialog-footer {
  text-align: center;
}
</style>
